import React, {SetStateAction, useCallback, useContext, useEffect, useRef, useState} from "react";
import './GarbageView.css'
import 'react-calendar/dist/Calendar.css';
import {Api} from "../../RequestsProvider/RequestProvider";
import HeadNavigation from "../../Components/HeadNavigation/HeadNavigation";
import CButton from "../../Components/Button/CButton";
import {
    ArrowRight,
    Search, Trash,
    XLg
} from "react-bootstrap-icons";
import {Context} from "../../ContextProvider/Context";
import Modal from "../../Components/Modal/Modal";
import product from "../../assets/images/fresh-produce.png";
import {GarbageCard} from "../../Components/GarbageCard/GarbageCard";
import moment from "moment";
import Calendar from "react-calendar";
import {toast} from "react-toastify";

export interface Garbage {
    id: number;
    garbageType: string;
    garbageDate: Date;
    isLoading?: boolean;
}

export const GarbageView = () => {

    const [garbage, setGarbage] = useState<Garbage[]>([])
    const [newUploadableGarbage, setNewUploadableGarbage] = useState<Garbage[]>([])
    const [newGarbageDate, setNewGarbageDate] = useState<Date | null>()
    const [newGarbageType, setNewGarbageType] = useState<string | null>()
    const [productFilter, setProductFilter] = useState("")
    const [showModal, setShowModal] = useState(false)
    const [showAddProductModal, setShowAddProductModal] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")

    const request = useContext(Api)
    const context = useContext(Context)
    const {getAllGarbageNotifications, addGarbage, deleteGarbage} = request!
    const {setContentLoading} = context!

    useEffect(() => {
        getAllGarbage().then()

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload)
        }
    }, [])
    useEffect(() => {
        setTimeout(() => setErrorMessage(""), 5000)
    }, [errorMessage])
    useEffect(() => {
        if (newUploadableGarbage.length === 0) {
            window.removeEventListener("beforeunload", handleBeforeUnload)
        }
    }, [newUploadableGarbage])

    useEffect(() => {
        if (!showAddProductModal) {
            setNewGarbageDate(null)
            setNewGarbageType(null)
            if (newUploadableGarbage.length > 0) {

                window.addEventListener("beforeunload", handleBeforeUnload)
                toast.warn(<>
                    <div className={"text-warning"}>Achtung!</div>
                    <small className={"text-muted"}>Die neuen Einträge müssen noch hochgeladen werden.</small>
                </>)
            }
        }
    }, [showAddProductModal])

    const handleBeforeUnload = useCallback((e: BeforeUnloadEvent) => {
        e.preventDefault()
        e.returnValue = ""
    }, [])

    const getAllGarbage = async () => {
        getAllGarbageNotifications().then(garbage => {
            setContentLoading(false)
            setGarbage(garbage.message)
        })
    }
    const _deleteGarbage = (garbageID: number) => {
        if (String(garbageID).startsWith("999")){
            setGarbage(prev => prev.filter(item => item.id !== garbageID))
            setNewUploadableGarbage(prev => prev.filter(item => item.id !== garbageID))
        }else{
            deleteGarbage(garbageID).then((resp)=>{
                if(resp.message){
                    setGarbage(prev => prev.filter(item => item.id !== garbageID))
                    toast.success("Datum erfolgreich entfernt.", {icon: <Trash/>})
                }else{
                    toast.error("Datum konnte nicht gelöscht werden.", {icon: <Trash/>})
                }
            })
        }
    }

    const deleteContainer = () => {

        return <>
            <div className="container text-center position-relative">
                <div className="row d-flex justify-content-center mb-5">
                    <img src={product} alt=""
                         className={"img-fluid p-3 rounded-circle"} style={{maxWidth: "130px"}}/>
                    <p className={"fs-5 fw-bolder"} style={{color: '#3C3C3C'}}>Müll wirklich löschen?</p>
                    <h6 className={''} style={{color: '#3C3C3C'}}>Test</h6>
                </div>
                <div className="position-absolute bottom-0 start-50 translate-middle-x">
                    <div className="row">
                        <button className={"modal-container-button"} onClick={() => {
                            //deleteProductNotification()
                        }}>Ja
                        </button>
                        <button className={"delete-button"} onClick={() => setShowModal(false)}>Nein</button>
                    </div>
                </div>
            </div>
        </>
    }
    const handleGarbageSearchChange = (event: { target: { value: SetStateAction<string> } }) => {
        setProductFilter(event.target.value)
    }
    const renderDeleteIcon = () => productFilter ?
        <XLg onClick={() => setProductFilter("")} className="delete-icon pointer"/> : null

    const addNewGarbage = () => {
        if (newGarbageDate && newGarbageType) {
            const newGarbage: Garbage = {
                id: Number('999'+new Date().getMilliseconds()),
                garbageType: newGarbageType,
                garbageDate: newGarbageDate,
                isLoading: true
            }
            setNewUploadableGarbage(prev => [...prev, newGarbage])
            setGarbage(prev => [...prev, newGarbage])
            setNewGarbageType(null)
            setNewGarbageDate(null)
        }

    }
    const addAllGarbage = ()=>{
        addGarbage(newUploadableGarbage).then(resp=>{
            setContentLoading(false)
            console.log(resp.message)
            if(resp.message){
                setNewUploadableGarbage([])
                toast.success("Die neuen Daten wurden erfolgreich hochgeladen.", {icon: <Trash/>})
                getAllGarbage().then()
            }else{
                toast.error("Die neuen Daten konnten nicht hochgeladen werden.", {icon: <Trash/>})
            }
            setShowAddProductModal(false)
        })
    }

    const addContainer = () => {

        return <>
            <div className="modal-container overflow-hiddenf">
                {newUploadableGarbage.length > 0 ? <div className="row w-50">
                    <button onClick={() => {
                        addAllGarbage()
                    }} className={"modal-container-button mb-3"} type={"submit"}>Hochladen
                    </button>
                </div> : <h2 className={"mb-2"} style={{color: '#3C3C3C'}}>Müll hinzufügen</h2>}
                <Calendar
                    tileClassName={({date, view}) => {
                        if (view === "month") {
                            const normalizedGarbage = garbage.map(g => ({
                                ...g,
                                garbageDate: new Date(g.garbageDate)
                            }));
                            const match = normalizedGarbage.find(
                                (g) =>
                                    date.getDate() === g.garbageDate.getDate() &&
                                    date.getMonth() === g.garbageDate.getMonth() &&
                                    date.getFullYear() === g.garbageDate.getFullYear()
                            );
                            return match ? `highlight-${match.garbageType}` : null;
                        }
                    }}
                    onClickDay={(value) => {
                        setNewGarbageDate(value)
                    }}
                />

                {newGarbageDate ? <div className="row mt-4">
                    <div className="col">
                        <button type="button" onClick={() => {
                            setNewGarbageType('gelb')
                        }} className={`garbage-btn garbage-btn--gelb ${newGarbageType === 'gelb' ? 'selected' : ''}`}>
                            <Trash/></button>
                    </div>
                    <div className="col">
                        <button type="button" onClick={() => {
                            setNewGarbageType('rest')
                        }} className={`garbage-btn garbage-btn--rest ${newGarbageType === 'rest' ? 'selected' : ''}`}>
                            <Trash/></button>
                    </div>
                    <div className="col">
                        <button type="button" onClick={() => {
                            setNewGarbageType('blau')
                        }} className={`garbage-btn garbage-btn--blau ${newGarbageType === 'blau' ? 'selected' : ''}`}>
                            <Trash/></button>
                    </div>
                </div> : null}
                {newGarbageType ? <div className="row mt-4">
                    <button onClick={() => {
                        addNewGarbage()
                    }} className={"modal-container-button"} type={"submit"}>Hinzufügen
                    </button>
                </div> : null}
            </div>
        </>
    }


    return (
        <>
            <HeadNavigation path={[{path: "/", pathName: "Startseite"}, {path: null, pathName: "Müll"}]}/>
            <Modal showModal={showAddProductModal} setShowModal={setShowAddProductModal} content={addContainer()}/>
            <Modal showModal={showModal} setShowModal={setShowModal} content={deleteContainer()}/>
            <div className="grid-padding">
                <div className="site-header d-flex justify-content-between align-items-center pb-1">
                    <h1>Müll-Erinnerungen <span>[{garbage.length}]</span></h1>
                    <CButton content={"Müll hinzufügen"} icon={<ArrowRight/>} onClick={() => {
                        setShowAddProductModal(true)
                    }}/>
                </div>
                <div className="search-input">
                    <Search className="search-icon"/>
                    <input value={productFilter} placeholder={"Suche nach Müll"} className="employee-search"
                           type="text"
                           onChange={handleGarbageSearchChange} disabled/>
                    {renderDeleteIcon()}
                </div>
                <div className="row pt-3 d-flex justify-content-center justify-content-sm-start">
                    {garbage.map((gab, idx) => {
                        let daysLeft = null
                        if (idx === 0 || idx === 1 || idx === 2) {
                            const today = moment().startOf('day')
                            const targetDate = moment(gab.garbageDate, "MM-DD-YYYY").startOf('day')
                            daysLeft = targetDate.diff(today, 'days')
                        }
                        return <GarbageCard key={gab.id} garbage={gab} daysLeft={daysLeft} deleteGarbage={_deleteGarbage}/>
                    })}
                </div>
            </div>
        </>
    )
}